import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { toastr } from "react-redux-toastr";

import axios from "../../config/axios";

class DuplicateTrailModal extends Component {
  constructor(props) {
    super(props);

    this.div = React.createRef();
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        size="md"
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Duplicar trilha</CModalTitle>
        </CModalHeader>
        <CModalBody className="d-flex align-items-center">
          <CButton
            block
            color="white"
            size="lg"
            className="flex-1 h-100"
            style={{ border: "1px solid rgba(0, 0, 0, 0.125)" }}
            onClick={this.props.onDeepDuplicate}
          >
            <i
              className="fa fa-copy mb-3"
              style={{ fontSize: "1.5rem", height: "auto" }}
            ></i>
            <div>Cópia completa</div>
            <div className="small" style={{ opacity: 0.6 }}>
              Copia as atividades da trilha para que você possa editar
            </div>
          </CButton>
          <span className="text-muted mx-3">ou</span>
          <CButton
            block
            color="white"
            size="lg"
            className="flex-1 h-100"
            style={{ border: "1px solid rgba(0, 0, 0, 0.125)" }}
            onClick={this.props.onDuplicate}
          >
            <i
              className="fa fa-file-o mb-3"
              style={{ fontSize: "1.5rem", height: "auto" }}
            ></i>
            <div>Cópia simples</div>
            <div className="small" style={{ opacity: 0.6 }}>
              Mantém uma ligação com as atividades da trilha original
            </div>
          </CButton>
        </CModalBody>
      </CModal>
    );
  }
}

export default DuplicateTrailModal;
